<template>

  <ModalContainer queryParam="f060" ref="modalContainer" size="lg">
    <b-alert 
      v-if="messageAlert" 
      show 
      :variant="messageAlert.variant"
      class="p-2 text-center"
    >
      {{ messageAlert.text }}
    </b-alert>
    
    <b-card class="mb-0">

    
      <h4 class="text-primary text-center mb-2">FORMULARIO CIRUGIA SEGURA</h4>

      
       <div class="mb-1 row p-1" v-if="dataProceso">
          <div class="col"><b>Procedimiento:</b> {{ dataProceso.procedimiento }}</div>
          <div class="col"><b>Paciente: </b> {{ dataProceso.paciente }}</div>
        </div>
      
      <b-row class="mb-1 d-flex align-items-center">
        <label class="col-2"><b>Quirófano: </b> </label>
        <b-form-select v-model="dataForm.quirofano" size="sm" class="col-4">
          <b-form-select-option :value="null">Escoja..</b-form-select-option>
          <b-form-select-option value="Sala de procedimiento">Sala de procedimiento</b-form-select-option>
        </b-form-select>
      </b-row>
      
      
      <b-tabs
        active-nav-item-class="font-weight-bold text-uppercase text-primary"
        content-class="mt-1"
      >
        <b-tab title="Entrada" active v-if="entrada">

          <b-row class="d-flex justify-content-between">
            <b-col cols="4">
              <span><b>El paciente ha confirmado:</b></span>
              <b-form-checkbox-group
                id="checkbox-group-confirmacion"
                v-model="entrada.confirmacion"
                :options="optionsConfirmacion"
                stacked
              />
            </b-col>

            <b-col cols="3">
              <span><b>Demarcacion del sitio quirúrgico:</b></span>
              <b-form-radio-group
                id="checkbox-group-demarcacion"
                v-model="entrada.demarcacion"
                :options="optionsSiNo"
                stacked
              />
            </b-col>

            <b-col cols="4">
              <span><b>Pulsoxímetro colocado en el paciente y funcionando</b></span>
              <b-form-radio-group
                id="checkbox-group-pulsimetro"
                v-model="entrada.pulsosimetro"
                :options="optionsSiNo"
                stacked
              />
            </b-col>
          </b-row>

          <hr class="my-2"/>

          <b-row>
            <b-col cols="7">
              <span><b>
                Se ha completado el control formal del instrumental
                anestésico, medicación y riesgo anestésico: (Sistema de
                ventilación)
              </b></span>

              <b-form-checkbox-group
                id="checkbox-group-instrumental"
                v-model="entrada.instrumental"
                :options="optionsInstrumentalA"
                stacked
              />
            </b-col>

            <b-col cols="5">
              <span><b>Tiene el paciente alergias conocidas:</b></span>
              <b-form-radio-group
                id="checkbox-group-alergias"
                v-model="entrada.alergias"
                :options="optionsSiNo"
                stacked
              />
              <div v-if="entrada.alergias === '1'">
                <label>Cuáles:</label>
                <b-form-textarea v-model="entrada.alergiasdesc"/> 
              </div>
            </b-col>

          </b-row>


          <hr class="my-2"/>

          <b-row>
            
            <b-col cols="3">
              <span><b>Capnógrafo colocado y funcionando</b></span>
              <b-form-radio-group
                id="checkbox-group-capnografo"
                v-model="entrada.capnografo"
                :options="optionsSiNo"
                stacked
              />
            </b-col>

            <b-col cols="3">
              <span><b>Vía aérea difícil / riesgo de aspiración</b></span>
              <b-form-radio-group
                id="checkbox-group-aereaDificil"
                v-model="entrada.aereadificil"
                :options="optionsSiNo"
                stacked
              />
            </b-col>

            <b-col cols="3">
              <span><b>Riesgo de hemorragia > 500 ml (7 ml/kg en niños)</b></span>
              <b-form-radio-group
                id="checkbox-group-riesgohemo"
                v-model="entrada.riesgohemo"
                :options="optionsSiNo"
                stacked
              />
            </b-col>

            <b-col cols="3">
              <span><b>Se ha confirmado la reserva de hemoderivados con el laboratorio</b></span>
              <b-form-radio-group
                id="checkbox-group-hemoderivados"
                v-model="entrada.hemoderivados"
                :options="optionsSiNo"
                stacked
              />
            </b-col>
          
          </b-row>
        
        </b-tab>


        <b-tab title="Pausa quirúrgica" v-if="pausa">
          <b-row>
            <b-col colS="6">
              <span>
                <b>Confirrmación que todos los miembros del equipo se han presentado por su nombre y función:</b>
              </span>

              <b-form-radio-group
                id="radio-group-confirmacionequipo"
                v-model="pausa.cequipo"
                :options="optionsSiNo"
                stacked
              />
            </b-col>

            <b-col cols="6">
              <span>
                <b>Responsable de la lista de chequeo confirma verbalmente con el equipo quirúrgico::</b>
              </span>
              <b-form-checkbox-group
                id="checkbox-group-confirmacionv"
                v-model="pausa.cverbal"
                :options="optionsConfirmacionVerbal"
              />
            </b-col>
          </b-row>

          <hr class="my-2"/>

          <b-row>

            <b-col cols="12" class="mb-2">
              <span><b>Previsión de eventos críticos</b></span>
              <b-form-checkbox-group
                id="radio-checkbox-eventoscriticos"
                v-model="pausa.eventosc"
                :options="optionsEventosC"
              />
            </b-col>

            <b-col cols="12">
              <span>
                <b>Equipo de enfermería y/o instrumentación quirúrgica revisa:</b>
              </span>

              <b-form-checkbox-group
                id="checkbox-group-instrumentacion"
                v-model="pausa.instrumentacion"
                :options="optionsInstrumentacion"
              />
            </b-col>
          </b-row>

          <hr class="my-2"/>

          <b-row>
            <b-col colS="6">
              <span>
                <b>Se ha administrado profilaxis antibiótica en los últimos 60 minutos</b>
              </span>

              <b-form-radio-group
                id="radio-checkbox-profilaxis"
                v-model="pausa.profilaxis"
                :options="optionsSiNo"
                stacked
              />

            </b-col>

            <b-col cols="6">
              <span>
                <b>Dispone de imágenes diagnosticas esenciales Para el procedimiento quirúrgico</b>
              </span>
              <b-form-radio-group
                id="checkbox-group-imagenes"
                v-model="pausa.imagenes"
                :options="optionsSiNo"
                stacked
              />
            </b-col>
          </b-row>
            
        </b-tab>


        <b-tab title="Salida" v-if="salida">
          <b-card class="small">
            <b-row>

              <b-col cols="12">
                <span>
                  <b>El responsable de la lista de chequeo confirma
                    verbalmente con el equipo quirúrgico:</b>
                </span>
              </b-col>

              <b-col cols="12" class="mt-1">                 
                <span>
                  El recuento FINAL de material blanco e
                  instrumental quirúrgico (previo al cierre) este completo 
                </span>
                <b-form-radio-group
                  id="checkbox-group-recuento"
                  v-model="salida.recuento"
                  :options="optionsSiNo" 
                />
              </b-col>
            </b-row>

            <hr class="my-2"/>

            <b-row>
              
              <b-col cols="6">
                <span><b>Hubo necesidad de empaquetar al paciente:</b></span>
                <b-form-radio-group
                  id="checkbox-group-empaquetado"
                  v-model="salida.empaquetado"
                  :options="optionsSiNo"
                  stacked
                />
              </b-col>

              <b-col cols="4">
                <span><b>Registre el numero de compresas:</b></span>
                <b-form-input
                  id="checkbox-group-numcompresas"
                  v-model="salida.numcompresas"
                />
              </b-col>

              <b-col cols="12" class="mt-1">
                <span><b>Nombre del procedimiento realizado:</b></span>
                  
                <SearchOpts
                  v-model="salida.procrealizado"
                  :searchService="procedimientosService.searchProcedimientosByTermSelect"
                  :placeholder="'Ingrese el nombre del procedimiento...'"
                  :establecimiento="establecimientoActual"
                  :data="salida.procrealizado"
                  class="form-control-sm"
                />
              </b-col>
            </b-row>
            
            <hr class="my-2"/>


            <b-row>
              <b-col cols="4">
                <span><b>Clasificacion de la herida:</b></span>
                <b-form-radio-group
                  id="checkbox-group-heridasclasif"
                  v-model="salida.heridasclasif"
                  :options="optionsClasH"
                  stacked
                />
              </b-col>
              <b-col cols="4">
                <span><b>Toma de muestras:</b></span>
                <b-form-radio-group
                  id="checkbox-group-tomamuestras"
                  v-model="salida.tomamuestras"
                  :options="optionsSiNo"
                  stacked
                />
              </b-col>
              
              <b-col cols="4">
                <span>
                  <b>Etiquetado de las muestras (nombres y apellidos completos
                    del paciente, historia clínica, fecha)</b>
                </span>

                <b-form-radio-group
                  id="checkbox-group-etiquetado"
                  v-model="salida.etiquetado"
                  :options="optionsSiNo"
                />
              </b-col>
            </b-row>
        
            <hr class="my-2"/>

            <b-row class="mt-1">

              <span class="col-12 text-center mb-1">
                <b>Identifique el tipo de muestra a enviar</b>
              </span>
              
              <b-col>
                <div>

                  <div>
                    <label>Citoquimico</label>
                    <b-form-checkbox
                      switch
                      v-model="salida.citoquimico.activo"
                      size="md"
                    />
                  </div>

                  <div class="mt-1" v-if="salida.citoquimico.activo">
                    <label>No.</label>
                    <b-form-input v-model="salida.citoquimico.numero"/>

                    <label>Nombre: </label>
                    <b-form-textarea v-model="salida.citoquimico.nombre"/>
                  </div>
                </div>
              </b-col>

              <b-col>
                <div>
                  <label>Cultivos</label>
                  <b-form-checkbox 
                    switch 
                    v-model="salida.cultivo.activo"
                  />
                </div>

                <div class="mt-1" v-if="salida.cultivo.activo">
                  <label>No.</label>
                  <b-form-input v-model="salida.cultivo.numero"/>

                  <label>Nombre: </label>
                  <b-form-textarea v-model="salida.cultivo.nombre"/>
                </div>
              </b-col>

              <b-col>
                <div>
                  <label>Anatomopatologico</label>
                  <b-form-checkbox
                    switch
                    v-model="salida.anatomopatologico.activo"
                  />
                </div>

                <div class="mt-1" v-if="salida.anatomopatologico.activo">
                  <label>No.</label>
                  <b-form-input v-model="salida.anatomopatologico.numero"/>

                  <label>Nombre: </label>
                  <b-form-textarea v-model="salida.anatomopatologico.nombre"/>
                </div>
              </b-col>

              <b-col>
                <div>
                  <label>Otros</label>
                  <b-form-checkbox
                    switch
                    v-model="salida.otros.value"
                  />
                </div>

                <div class="mt-1" v-if="salida.otros.value">
                  <b-form-textarea v-model="salida.otros.descripcion"/>
                </div>
              </b-col>
            </b-row>

            <hr />


            <b-row class="mt-1">
              <b-col>
                <span>
                  <b>Si hay problemas que resolver, relacionados con el
                    instrumental y los equipos</b>
                </span>

                <b-form-radio-group
                  id="checkbox-group-probinstrumental"
                  v-model="salida.probinstrumental.value"
                  :options="optionsSiNo"
                />

                <b-form-textarea
                  class="mt-1"
                  v-if="salida.probinstrumental.value === '1'"
                  v-model="salida.probinstrumental.descripcion"
                  placeholder="Describa problemas.."
                />
              </b-col>
            </b-row>

            <b-row class="mt-1">
              <b-col>
                <span>
                  <b>El cirujano, el anestesiólogo y el personal de enfermería
                    revisan los principales aspectos de la recuperación del
                    paciente.
                  </b>
                </span>
                <b-form-radio-group
                  id="checkbox-group-recuperacion"
                  v-model="salida.recuperacion"
                  :options="optionsSiNo"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-tab>

    
        <b-tab title="Profesionales responsables" v-if="responsables">

          <b-row class="mt-3 d-flex align-items-center">
            <label class="col-3"><b>Cirujano: </b> </label>
            <SearchOpts
              class="col-9"
              v-model="responsables.cirujano"
              :searchService="doctoresService.searchDoctoresByTermSelect"
              :placeholder="'Ingrese los apellidos o nombres...'"
              :data="responsables.cirujano"
              :minChars="3"
            />
          </b-row>

          <b-row class="mt-2 d-flex align-items-center">
            <label class="col-3"><b>Responsable lista de verificacion: </b> </label>
            <SearchOpts
              class="col-9"
              v-model="responsables.encarlista"
              :data="responsables.encarlista"
              :searchService="auxiliarService.searchAuxiliaresByTermSelect"
              :placeholder="'Ingrese los apellidos o nombres...'"
              :minChars="3"
            />
          </b-row>


          <b-row class="mt-2 d-flex align-items-center">
            <label class="col-3"><b>Anestesiólogo: </b> </label>
            <SearchOpts
              class="col-9"
              v-model="responsables.anestesiologo"
              :data="responsables.anestesiologo"
              :searchService="doctoresService.searchDoctoresByTermSelect"
              :placeholder="'Ingrese los apellidos o nombres...'"
              :minChars="3"
            />
          </b-row>
        </b-tab>

      </b-tabs>


      <div class="d-flex justify-content-end mt-3">
        <b-button 
          variant="success" 
          @click="onSaveDataForm"
        >
          Guardar
        </b-button>
      </div>
      
    </b-card>

  </ModalContainer>
  
</template>

<script>
import "flatpickr/dist/flatpickr.css";
import { SearchOpts, ModalContainer } from "@/shared/components";
import { doctoresService, auxiliarService, procedimientosService } from "@/shared/services";
import { getDataForms } from "../../helpers/getDataForms";
import { procedimientosFormulariosService } from "../../services";

export default {
  components: {
    SearchOpts,
    ModalContainer
  },


  data() {
    return {

      codigoFormulario: "060",

      

      establecimientoActual : '',
      procedimientosService,
      messageAlert: null,

      dataForm : {
        quirofano : null,
        entrada : null,
        pausa : null,
        salida: null,
        responsables : null,
      }, 

      entrada: null,
      pausa: null,
      salida: null,
      responsables: null,

      entradaInit: {
        confirmacion: [],
        demarcacion: "",
        pulsosimetro: "",
        instrumental: [],
        alergias: "",
        alergiasdesc:"",
        capnografo: "",
        aereadificil: "",
        riesgohemo: "",
        hemoderivados: "",
      },

      pausaInit: {
        cequipo: "",
        cverbal: [],
        eventosc: [],
        instrumentacion: [],
        profilaxis: "",
        imagenes: "",
      },

      salidaInit: {
        recuento: "",
        empaquetado: "",
        numcompresas: null,
        procrealizado: null,
        heridasclasif: "",
        tomamuestras: "",
        etiquetado: "",

        citoquimico: {
          activo: false,
          numero: null,
          nombre: "",
        },

        cultivo: {
          activo: false,
          numero: null,
          nombre: "",
        },

        anatomopatologico: {
          activo: false,
          numero: null,
          nombre: "",
        },

        otros: {
          activo: false,
          descripcion: "",
        },

        probinstrumental: {
          value: "2",
          descripcion: "",
        },

        recuperacion: ''
      },

      responsablesInit: {
        cirujano: null,
        encarlista: null,
        anestesiologo: null,
      },

      optionsClasH: [
        { text: "Limpia", value: "1" },
        { text: "Contaminada", value: "2" },
        { text: "Limpia-contaminada", value: "3" },
        { text: "Sucia", value: "4" },
      ],
      optionsSiNo: [
        { text: "Si", value: "1" },
        { text: "No", value: "2" },
        { text: "No procede", value: "3" },
      ],
      optionsConfirmacion: [
        { text: "Su identidad", value: "1" },
        { text: "Sitio quirúrgico", value: "2" },
        { text: "Procedimiento(lateralidad)", value: "3" },
        { text: "Su consentimiento verbal y escrito", value: "4" },
      ],
      optionsEventosC: [
        { text: "(El cirujano expresa)Duracion del procedimiento", value: "1" },
        { text: "(El cirujano expresa)Perdida prevista de sangre", value: "2" },
        { text: "(El anestesiologo expresa) algun problema especifico", value: "3" },
      ],
      optionsInstrumentacion: [
        {
          text: "Esterilidad (con resultado de Indicadores e integradores químicos internos y externos)",
          value: "1",
        },
        {
          text: "Recuento INICIAL de material blanco e Instrumental quirúrgico",
          value: "2",
        },
        {
          text: "Dudas o problemas relacionados con el instrumental y equipos.",
          value: "3",
        },
      ],
      optionsConfirmacionVerbal: [
        { text: "Identidad del paciente", value: "1" },
        { text: "Sitio quirúrgico", value: "2" },
        { text: "Procedimiento (lateralidad)", value: "3" },
      ],
      optionsInstrumentalA: [
        { text: "Equipo de intubación", value: "1" },
        { text: "Equipo de aspiración de la vía aérea", value: "2" },
        { text: "Oxigeno", value: "3" },
        { text: "Fármacos inhalados", value: "4" },
        { text: "Medicación", value: "5" },
      ],
      idProcActual: null,
      doctoresService,
      auxiliarService,
      fechaActual: null,
      horaActual: null,
      birthDateConfig: {
        allowInput: true,
        dateFormat: "Y-m-d", // Solo fecha
      },
      procedimiento: [],
      tokenFormulario: null,
    };
  },

  created() {

    const usuario = JSON.parse(localStorage.getItem("detalleusuario"))
    this.establecimientoActual = usuario ? usuario.establecimiento.id : ''

    this.loadData();
    
  },

  methods: {

    async loadData() {

      this.messageAlert = {
        text:"No existe informacion registrada",
        variant:"info"
      };

      this.dataForm.quirofano = null;
      this.entrada      =  { ...this.entradaInit };
      this.pausa        =  { ...this.pausaInit };
      this.salida       =  { ...this.salidaInit };
      this.responsables =  { ...this.responsablesInit };

      this.tokenProceso = this.$route.query.forms;
      this.tokenFormulario = this.$route.query.f060;

      const response = await procedimientosFormulariosService.obtenerFormProcDataByToken(this.tokenFormulario);

      if(!response) {
       
        return
      } 

      let paciente = `${response.procedimientoCita.consultamedica.cita.paciente.persona.primerApellido} ${response.procedimientoCita.consultamedica.cita.paciente.persona.primerNombre} `

  
      this.messageAlert = {
        text:"Info cargada",
        variant:"success"
      };

      let dataForm = null
      try{
        dataForm = JSON.parse(response.dataJson)
      }catch(error){console.log("error", error)}

      if(!dataForm) return;

      this.dataForm.quirofano = dataForm.quirofano;
      this.entrada = dataForm.entrada ?? this.entradaInit;
      this.pausa   = dataForm.pausa   ?? this.pausaInit;
      this.salida  = dataForm.salida  ?? this.salidaInit;
      this.responsables = dataForm.responsables ?? this.responsablesInit;
    },

    
    async onSaveDataForm() {

      const params = {
        nameForm       : this.codigoFormulario,
        dataJson       : JSON.stringify(this.dataForm),
        tokenProceso   : this.tokenProceso,
        tokenFormulario: this.tokenFormulario,
        idRegistroForm : this.idRegistroForm
      }

      const responseSave = await procedimientosFormulariosService.guardarData(params);

      if (!responseSave) {
        this.$swal({
          title: "Error",
          text: "No se guardo! Contacte al equipo de desarrollo",
          icon: "error",
          confirmButtonColor: "#089599",
        });

        return;
      }

      await this.$swal.fire({
        icon: "success",
        text: "Guardado correctamente",
      });

      this.$emit("formulario-guardado");
      
      await this.$router.push({ query: { ...this.$route.query, f060: undefined } });

      //this.$router.go(0);
      
    },
  },
  props:{
    dataProceso:{
      required:false,
      default:null
    }
  },

  watch: {

    '$route.query.f060': {
      handler(newValue){
        if(newValue){
        this.loadData();
        }
      },
    },

    'entrada.alergias':
    {
      deep: true,
      handler(newValue){
        if (newValue === '2' || newValue === '3'){

          this.entrada.alergiasdesc = ''
        }
      }
    },

    'salida.probinstrumental.value':
    {
      deep: true,
      handler(newValue){
        if(newValue !== '1'){
          this.salida.probinstrumental.descripcion = ''
        }
      }
    },


    'salida.anatomopatologico.activo':
    {
      deep: true,
      handler(newValue){
        if (!newValue)
          this.$nextTick(() => {
            this.salida.anatomopatologico.numero = '';
            this.salida.anatomopatologico.nombre = '';
          });
      }
    },


    'salida.citoquimico.activo':
    {
      deep: true,
      handler(newValue){
        if(!newValue)
          this.$nextTick(() => {
            this.salida.citoquimico.numero = ''
            this.salida.citoquimico.nombre = ''
          })
      }
    },


    'salida.cultivo.activo':
    {
      deep: true,
      handler(newValue){
        if(!newValue){
          this.$nextTick(() => {
            this.salida.cultivo.numero = ''
            this.salida.cultivo.nombre = ''
          })
        }
      }
    },

    'salida.otros':
    {
      deep: true,
      handler(newValue){
        if(newValue && !newValue.value){
          this.salida.otros.descripcion = ''
        }
      }
    },

    dataForm: {
      deep: true,
      handler(newValue) {
        // localStorage.setItem("formCirSegura", JSON.stringify(newValue))
        console.log("dataForm", newValue);
      },
    },

    entrada: {
      deep: true,
      handler(newValue) {
        this.dataForm.entrada = newValue
      },
    },
    
    pausa: {
      deep: true,
      handler(newValue) {
        this.dataForm.pausa = newValue
      },
    },

    salida: {
      deep: true,
      handler(newValue) {
        this.dataForm.salida = newValue
      },
    },

    responsables: {
      deep: true,
      handler(newValue) {
        this.dataForm.responsables = newValue
      },
    },

  },
};
</script>
